import type { ReactNode } from 'react'
import type { User } from '@/api/types'
import { SessionCtx, SessionRefreshCtx } from '@/hooks/useSession'

export function SessionProvider({ user, refresh, children }: { user: User; refresh?: () => void; children: ReactNode }) {
  return (
    <SessionCtx.Provider value={user}>
      <SessionRefreshCtx.Provider value={refresh ?? (() => undefined)}>{children}</SessionRefreshCtx.Provider>
    </SessionCtx.Provider>
  )
}
